import { useEffect, useState } from 'react';
import { topics, type ConversationId } from '@cyphex/types';
import { getRealtime, type ConnectionState } from '../api';

/**
 * Subscribes the open conversation and reports the connection state.
 *
 * It deliberately does NOT apply events: `RealtimeRuntime` owns the single
 * reducer for the whole app. One socket, one place that writes the cache — two
 * appliers would double-count every reaction the moment chat and a channel feed
 * were open at the same time.
 */
export function useChatRealtime(conversationId: ConversationId | null): ConnectionState {
  const [state, setState] = useState<ConnectionState>(() => getRealtime().state());

  useEffect(() => {
    const realtime = getRealtime();
    realtime.connect();
    return realtime.onState(setState);
  }, []);

  useEffect(() => {
    if (!conversationId) return undefined;
    const realtime = getRealtime();
    const topic = topics.conversation(conversationId);
    realtime.subscribe([topic]);
    return () => realtime.unsubscribe([topic]);
  }, [conversationId]);

  return state;
}
